import { render, staticRenderFns } from "./DeadlineList.vue?vue&type=template&id=86206c9e&scoped=true"
import script from "./DeadlineList.vue?vue&type=script&lang=ts"
export * from "./DeadlineList.vue?vue&type=script&lang=ts"
import style0 from "./DeadlineList.vue?vue&type=style&index=0&id=86206c9e&prod&lang=css"
import style1 from "./DeadlineList.vue?vue&type=style&index=1&id=86206c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86206c9e",
  null
  
)

export default component.exports